var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p-img',{class:_vm.classList,attrs:{"cover":_vm.cover,"ratio":_vm.ratio,"src":_vm.picturePath,"width":_vm.width,"height":_vm.height}})}
var staticRenderFns = []

export { render, staticRenderFns }